import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { useEffect, useState } from "react"

import { Tooltip } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./style.css"

const ScrollToTop = () => {
	const { t } = useTranslation()
	const [isVisible, setIsVisible] = useState(false)

	const toggleVisibility = () => {
		if (window.pageYOffset > 300) {
			setIsVisible(true)
		} else {
			setIsVisible(false)
		}
	}

	useEffect(() => {
		window.addEventListener("scroll", toggleVisibility)
		return () => {
			window.removeEventListener("scroll", toggleVisibility)
		}
	}, [])

	const scrollToTop = () => {
		window.scrollTo({ top: 0, behavior: "smooth" })
	}

	return (
		<div className="scroll-to-top">
			{isVisible && (
				<Tooltip title={t("scrollToTop", { ns: "common" })}>
					<button onClick={scrollToTop}>
						<KeyboardArrowUpIcon />
					</button>
				</Tooltip>
			)}
		</div>
	)
}

export default ScrollToTop
